module.exports = __webpack_public_path__ + "static/media/paltech.1bb37cd8.png";